import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';

import { Breadcrumbs } from '../../components/Breadcrumbs';
import {
  PATH_INTERNAL_ORGANIZATIONS,
  PATH_INTERNAL_ORGANIZATIONS_NEW,
  PATH_INTERNAL_THIRD_PARTIES_DEFAULT,
} from '../../app/constants/paths.constant';
import { OrganizationForm } from '../../forms/ThirdParty/Organization';
import { FormVariant } from '../../forms';
import { Page } from '../../contexts/NavigationContext/enums/page.enum';
import { useNavigationContext } from '../../contexts/NavigationContext/hooks/useNavigationContext.hook';
import { buildDocumentTitle } from '../../utils/document-title.util';
import { PageTitle } from '../../components/PageTitle';

export const NewInternalOrganizationPage = () => {
  const { setPage } = useNavigationContext();

  useEffect(() => {
    setPage(Page.InternalThirdParties);
  }, [setPage]);

  return (
    <>
      <Helmet>
        <title>{buildDocumentTitle("Création d'une Société SOCNA")}</title>
      </Helmet>
      <Breadcrumbs
        paths={[
          {
            to: PATH_INTERNAL_THIRD_PARTIES_DEFAULT,
            label: 'organisation socna',
            key: 'internalThirdParties',
          },
          {
            to: PATH_INTERNAL_ORGANIZATIONS,
            label: 'sociétés',
            key: 'internalOrganizations',
          },
          {
            to: PATH_INTERNAL_ORGANIZATIONS_NEW,
            label: 'nouvelle',
            key: 'newInternalOrganization',
          },
        ]}
      />
      <PageTitle title="Création d'une Société SOCNA" />
      <OrganizationForm
        formVariant={FormVariant.Creation}
        isInternal
        showCancelButton={false}
      />
    </>
  );
};
